import type { SVGProps } from 'react';

export function InfinexIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.6 15a1 1 0 0 0 1 1h5.2a1 1 0 0 0 1-1v-4.4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H2.6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1z" />
      <path d="M22.4 19a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9a1 1 0 0 0-1-1h-5.2a1 1 0 0 0-1 1v4.4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h13.2a1 1 0 0 1 1 1z" />
    </svg>
  );
}
